import { Button } from '@/components/ui/button.js'
import { NoticePage } from '../components/common/NoticePage.js'
import { sessionEndTarget } from '@/features/auth/api.js'

export function Unauthorized() {
  return (
    <NoticePage
      icon="🔒"
      title="Session expired"
      action={
        <Button asChild>
          <a href={sessionEndTarget()}>Log in again</a>
        </Button>
      }
    >
      Your session is invalid or has expired. Please log in again to continue.
    </NoticePage>
  )
}
